import { useCallback, useEffect, useMemo, useState } from "react";
import useAxiosClient from "../axios-client";
import { toast } from "react-toastify";

export const useProductFormations = ({ includeLegacy = false } = {}) => {

    const axiosClient = useAxiosClient();
    const [productFormations, setProductFormations] = useState([]);
    const [productFormationsLoading, setProductFormationsLoading] = useState(false);

    const fetchProductFormations = useCallback(async () => {
        setProductFormationsLoading(true);
        const params = includeLegacy ? { include_legacy: 1 } : {};
        await axiosClient.get(`/settings/productFormations/index`, { params }).then((response) => {
            setProductFormations([...response.data.data]);
            setProductFormationsLoading(false);
        }).catch((error) => {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            setProductFormationsLoading(false);
            toast.error(message);
        });
    }, [axiosClient, includeLegacy]);

    useEffect(() => {
        fetchProductFormations();
    }, [fetchProductFormations]);

    const formationsByType = useMemo(() => {
        const map = {};
        productFormations
            .filter((f) => !f.is_legacy && f.product_type_id != null)
            .forEach((f) => {
                if (!map[f.product_type_id]) {
                    map[f.product_type_id] = [];
                }
                map[f.product_type_id].push(f);
            });
        return map;
    }, [productFormations]);

    const activeFormations = useMemo(() => {
        return productFormations.filter((f) => !f.is_legacy);
    }, [productFormations]);

    return {
        productFormations,
        formationsByType,
        activeFormations,
        productFormationsLoading,
        fetchProductFormations,
    };
};
